import React from "react";
import { IconButton } from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import { intl } from "i18n/provider";

const defaultProps = {
  buttonProps: {},
  iconProps: {},
};

export default function RefreshButton({ onClick, buttonProps, iconProps }) {
  // console.log("RefreshButton => onClick", c);
  return (
    <React.Fragment>
      <IconButton
        onClick={onClick}
        title="Refresh"
        sx={{
          margin: 0,
          padding: "6px",
          minWidth: "32px",
          height: "32px",
          borderRadius: "6px",
          backgroundColor: "#f5f5f5",
          transition: "all 0.2s ease",
          "&:hover": {
            backgroundColor: "#e8e8e8",
            transform: "translateY(-1px)",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
          },
          "&:active": {
            transform: "translateY(0)",
            boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
          },
        }}
        {...buttonProps}
      >
        <RefreshIcon 
          sx={{ 
            fontSize: "20px", 
            color: "#2196F3",
            margin: 0 
          }} 
          {...iconProps} 
        />
      </IconButton>
    </React.Fragment>
  );
}

RefreshButton.defaultProps = defaultProps;
